module.exports = __webpack_public_path__ + "static/media/unload-image.13ad0d66.svg";